import React, { useState, useEffect, useContext } from 'react';
import Header from '../../components/Header';
import { db } from '../../services/firebaseConnection';
import { collection, getDocs, deleteDoc, doc, getDoc } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { FiEdit2, FiPlus } from 'react-icons/fi';
import { FaRegTrashAlt, FaCity } from "react-icons/fa";
import { toast } from 'react-toastify';
import { AuthContext } from '../../contexts/auth'; 

export default function Cidade() {
  const [cidades, setCidades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'ascending' });
  const { user } = useContext(AuthContext); 
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const getCidadeFromDatabase = async () => {
      try {
        const cidadeSnapshot = await getDocs(collection(db, 'Cidade'));
        const cidadeData = cidadeSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setCidades(cidadeData);
        setLoading(false);
      } catch (error) {
        console.error('Erro ao buscar cidade:', error);
        setLoading(false);
      }
    };

    getCidadeFromDatabase();
  }, []);

  useEffect(() => {
    async function loadPermissions() {

      const storedUser = localStorage.getItem('@userLogado');
      if (!storedUser) {
        console.error('Usuário não encontrado no localStorage.');
        return;
      }

      const userData = JSON.parse(storedUser);
      const cargoId = userData?.cargo;

      if (!cargoId) {
        console.error('ID do cargo não encontrado no usuário.');
        return;
      }

      try {
        const cargoRef = doc(db, 'Cargo', cargoId);
        const cargoDoc = await getDoc(cargoRef);

        if (cargoDoc.exists()) {
          const cargoData = cargoDoc.data();

          setPermissions(cargoData.permissoes || []);
        } else {
          console.error('Documento do cargo não encontrado no Firestore.');
        }
      } catch (error) {
        console.error('Erro ao buscar permissões no Firestore:', error);
      }
    }

    loadPermissions();
  }, []);

  const hasPermission = (permission) => {
    return permissions.includes(permission);
  };

  const handleDelete = async (id) => {
    try {
      const cidadeRef = doc(db, 'Cidade', id);
      await deleteDoc(cidadeRef);
      toast.success('Cidade excluída com sucesso!');
      setCidades(cidades.filter(cidade => cidade.id !== id));
    } catch (error) {
      console.error('Erro ao excluir cidade:', error);
      toast.error('Erro ao excluir cidade.');
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const sortedCidades = React.useMemo(() => {
    let sortableCidades = [...cidades];
    if (sortConfig.key) {
      sortableCidades.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableCidades;
  }, [cidades, sortConfig]);

  const filteredCidades = sortedCidades.filter(cidade =>
    cidade.nome.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <Header />

      <div className="content">
        <div className="title-container">
          <div className="title-left">
            <FaCity size={25} />
            <h1>Cidades</h1>
          </div>
          <Link to="/cidade/new" className="title-link incluir">
            <FiPlus color="#FFF" size={25} />
            <span>Incluir cidade</span>
          </Link>
        </div>

        <div className="container dashboard">
          {loading && <span>Carregando cidades...</span>}
          {!loading && cidades.length === 0 && <span>Nenhuma cidade encontrada...</span>}
        </div>

        <input
          type="text"
          className="filter-container"
          placeholder="Buscar por nome..."
          value={searchTerm}
          onChange={handleSearchChange}
        />

        {!loading && cidades.length > 0 && (
          <table>
            <thead>
              <tr>
                <th onClick={() => handleSort('nome')}>Nome</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {filteredCidades.map((cidade, index) => (
                <tr key={index}>
                  <td data-label="Nome">{cidade.nome}</td>
                  <td data-label="Ação">
                    <Link to={`/cidade/edit/${cidade.id}`} className="action" style={{ backgroundColor: '#03c9e9' }}>
                      <FiEdit2 color='#FFF' size={17} />
                    </Link>
                    {hasPermission('deletar_itens') && (
                      <button
                        className="action"
                        style={{ backgroundColor: '#e90303' }}
                        onClick={() => handleDelete(cidade.id)}
                      >
                        <FaRegTrashAlt color="#FFF" size={17} />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
